import { createClient } from '@/shared/api';
import type {
  UpdateSupportRequestMutation,
  UpdateSupportRequestMutationVariables,
} from '@/shared/api';
import UPDATE_SUPPORT_REQUEST from '../mutations/updateSupportRequest';

/**
 * Updates an existing clinic support request. Runs the UPDATE_SUPPORT_REQUEST mutation, throws the returned message when isSuccess is false, and returns the updated clinicTicket.
 *
 * @param input - Mutation input payload.
 * @returns The updated clinic ticket.
 */
const handleUpdateSupportRequest = async (
  input: UpdateSupportRequestMutationVariables['input'],
): Promise<
  NonNullable<UpdateSupportRequestMutation['updateSupportRequest']>['clinicTicket'] | undefined
> => {
  const client = createClient();
  const result = await client.mutate<
    UpdateSupportRequestMutation,
    UpdateSupportRequestMutationVariables
  >({
    mutation: UPDATE_SUPPORT_REQUEST,
    variables: { input },
  });
  const { isSuccess, message, clinicTicket } = result.data?.updateSupportRequest || {};

  if (!isSuccess) {
    throw new Error(message ?? undefined);
  }
  return clinicTicket;
};

export default handleUpdateSupportRequest;
